<template>
  <el-dialog
      :visible.sync="visible"
      title="库存调配"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
    >
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="调仓时间：" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="`选择出调配时间`"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="新合同号：" prop="orderCode">
            <order-drop v-model="dataForm.orderCode" size="mini"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注：" label-width="70px" prop="remark">
            <el-input v-model="dataForm.remark" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <SweetTable ref="table" :data="dataForm.detailList" :height="500" :is-page="false">
        <el-table-column
            label="调出方"
            prop="senderName"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            label="接收方"
            header-align="center"
            align="center"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.receiverId'"
                :rules="detailRule.receiverId"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <company v-model="row.receiverId" size="mini"></company>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="品番号"
            prop="product.code"
            header-align="center"
            align="center"
            v-if="productType==='产品'"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.code'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.code" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="SKU"
            prop="product.skuCode"
            header-align="center"
            align="center"
            v-if="productType==='产品'"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.skuCode'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.skuCode" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="品名"
            prop="product.name"
            header-align="center"
            align="center"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.name'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.name" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="中文品名"
            prop="product.nameZh"
            header-align="center"
            align="center"
            v-if="productType==='产品'"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.nameZh'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.nameZh" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="product.color"
            header-align="center"
            align="center"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.color'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.color" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="规格"
            prop="product.size"
            header-align="center"
            align="center"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.size'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.size" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="幅宽"
            prop="product.attr1"
            header-align="center"
            align="center"
            v-if="productType==='原料'"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.attr1'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.attr1" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="克重"
            prop="product.attr2"
            header-align="center"
            align="center"
            v-if="productType==='原料'"
        >
          <template #default="{row,$index}">
            <el-form-item
                :prop="'detailList.' + $index + '.product.attr2'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="row.product.attr2" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="成本单价"
            prop="price"
            header-align="center"
            align="center"
            width="160"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.price" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="调出数量" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right" header-align="center" align="center">
          <template #default="{row,$index}">
            <el-button type="text" @click="removeRow(row,$index)">移除</el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <div>
        <div>

        </div>
        <div>
          <el-button @click="cancel" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="doSubmit()" size="mini">确认调仓</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { isNumber, moneyValidator } from '@/utils/validate'

export default {
  props: {
    productType: ''
  },
  data () {
    return {
      dataForm: {},
      visible: false,
    }
  },
  computed: {
    dataRule () {
      return {
        shippingCost: [{ validator: moneyValidator, trigger: 'change' }],
        receiverId: [
          { required: true, message: '请选择接收方', trigger: 'change' },
        ],
        operateTime: [
          { required: true, message: '请选择调仓时间', trigger: 'change' },
        ],
      }
    },
    detailRule () {
      return {
        receiverId: [
          { required: true, message: '请选择接收方', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          {
            validator: moneyValidator
          }
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    cancel () {
      this.visible = false
    },
    init () {
      this.visible = true
      this.reset()
    },
    reset () {
      this.dataForm = {
        ...this.dataForm,
        orderCode: '',
        receiverId: '',
        shippingCost: '',
        remark: '',
        operateTime: '',
        batchCode: ''
      }
      this.queryUpStore()
      if (this.$refs.dataForm) {
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      }
    },
    removeRow (row, $index) {
      this.$confirm(`是否要将改行数据移出本次操作?`).then(() => {
        this.dataForm.detailList.splice($index, 1)
      })
    },
    async queryUpStore () {
      let loading = this.$loading()
      let params = this.dataForm.detailList.map(row=>{
        return {
          agreementId: row.agreementId,
          productId:row.productId
        }
      })
      try {
        let dataList = await this.$api2.post(`/erp/store/transfer/upflow`, params)
        if (dataList) {
          dataList.forEach(row => {
            row.count = ''
            row.showReason = '相关物料'
            row.senderId=row.receiverId
            row.senderName=row.receiverName
            row.receiverId=''
            row.receiverName=''
          })
        }
        this.dataForm.detailList = this.dataForm.detailList.concat(dataList)
        loading.close()
      } catch (e) {
        console.log(e)
        loading.close()
      }
    },
    async doSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.$confirm('是否进行库存调配操作?', '操作提示').then(() => {
          this.saveData()
        })
      })
    },
    async saveData () {
      let postForm = this.$clone(this.dataForm)
      postForm.detailList = postForm.detailList.map((item) => {
        return {
          id: item.id,
          agreementId: item.agreementId,
          count: item.count,
          senderId: item.senderId,
          receiverId: item.receiverId,
          product: {
            ...item.product,
            type: this.productType
          }
        }
      })
      try {
        const res = await this.$api2.post(`/erp/store/transfer`, postForm)
        this.$message.success('操作成功')
        this.$emit('change')
        this.visible = false
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
